__turbopack_context__.v({
  "frame": "StoneThumbnail-module__pqqAVW__frame",
  "label": "StoneThumbnail-module__pqqAVW__label",
  "picture": "StoneThumbnail-module__pqqAVW__picture",
  "stone": "StoneThumbnail-module__pqqAVW__stone",
  "stone-crossfade": "StoneThumbnail-module__pqqAVW__stone-crossfade",
  "stone-gentle-spin": "StoneThumbnail-module__pqqAVW__stone-gentle-spin",
  "thumbnail": "StoneThumbnail-module__pqqAVW__thumbnail",
});
